<template>
  <section class="menu-admin" :class="{ 'open' : open }">
    <div class="menu-header">
      <div @click="push('/')" class="menu-logo">
        <img src="img/swiss.png">
      </div>
      <div @click="open = !open" class="menu-icon">
        <transition name="pop" mode="out-in">
          <i v-if="open" class="fas fa-times"></i>
          <i v-else class="fas fa-bars"></i>
        </transition>
      </div>
    </div>
    <div class="menu-items">
      <div @click="push('/assinatura')" class="menu-item" :class="{ 'active' : isRoute('/assinatura') }">
        <i class="fas fa-handshake"></i>
        <span>Assinatura</span>
      </div>
      <div
        v-if="hasDashAccess"
        @click="push('/dashboard')"
        class="menu-item"
        :class="{ 'active' : isRoute('/dashboard') }"
      >
        <i class="fas fa-chart-pie"></i>
        <span>Dashboard</span>
      </div>
      <div @click="push('/usuario')" class="menu-item" :class="{ 'active' : isRoute('/usuario') }">
        <i class="fas fa-user-friends"></i>
        <span>Perfil</span>
      </div>
      <div @click="push('/educacional')" class="menu-item" :class="{ 'active' : isRoute('/educacional') }">
        <i class="fas fa-graduation-cap"></i>
        <span>Educacional</span>
      </div>
      <!-- <div @click="push('/transaction')" class="menu-item" :class="{ 'active' : isRoute('/transaction') }">
        <i class="fas fa-dollar-sign"></i>
        <span>Faturamento</span>
      </div> -->
      <!-- <div @click="push('/event-dates')" class="menu-item" :class="{ 'active' : isRoute('/analytics') }">
        <i class="fas fa-calendar-alt"></i>
        <span>Agenda</span>
      </div>
      <div @click="push('/showcase')" class="menu-item" :class="{ 'active' : isRoute('/showcase') }">
        <i class="fas fa-object-group"></i>
        <span>Vitrine</span>
      </div> -->
      <!-- <div @click="push('/product')" class="menu-item" :class="{ 'active' : isRoute('/product') }">
        <i class="fas fa-gift"></i>
        <span>Produtos</span>
      </div> -->
      <!-- <div @click="push('/business')" class="menu-item" :class="{ 'active' : isRoute('/business') }">
        <i class="far fa-building"></i>
        <span>Estabelecimentos</span>
      </div>
      <div @click="push('/show')" class="menu-item" :class="{ 'active' : isRoute('/show') }">
        <i class="far fa-calendar-check"></i>
        <span>Eventos</span>
      </div> -->
      <!-- <div @click="push('/log')" class="menu-item" :class="{ 'active' : isRoute('/log') }">
        <i class="fas fa-list"></i>
        <span>Logs</span>
      </div> -->
      <!-- <div @click="push('/payment')" class="menu-item" :class="{ 'active' : isRoute('/payment') }">
        <i class="fas fa-money-check-alt"></i>
        <span>Pagamentos</span>
      </div> -->
      <!-- <div @click="push('/courtesy')" class="menu-item" :class="{ 'active' : isRoute('/courtesy') }">
        <i class="fas fa-gift"></i>
        <span>Cortesias</span>
      </div>
      <div @click="push('/producer')" class="menu-item" :class="{ 'active' : isRoute('/producer') }">
        <i class="fas fa-user-tie"></i>
        <span>Produtores</span>
      </div>
      <div @click="push('/settings')" class="menu-item" :class="{ 'active' : isRoute('/settings') }">
        <i class="fas fa-cog"></i>
        <span>Configurações</span>
      </div> -->
    </div>
    <div>
      <div @click="signOut" class="menu-item">
        <i class="fas fa-sign-out-alt"></i>
        <span>Sair</span>
      </div>
    </div>
  </section>
</template>

<script>
import { removeToken, loadModule } from '../../util'
import { getAccess } from '../api/dash'
import logger from '../../logger'

export default {
  name: 'Menu',
  data () {
    return {
      open: false,
      hasDashAccess: false
    }
  },
  async mounted () {
    await this.checkDashAccess()
  },
  methods: {
    async checkDashAccess () {
      try {
        const data = await getAccess()
        this.hasDashAccess = Boolean(data && data.access)
      } catch (error) {
        this.hasDashAccess = false
        logger.error(error, this)
      }
    },
    async push (path) {
      this.open = false
      await this.$router.push(path)
    },
    isRoute (path) {
      if (this.$route.path.split('/')[1] === path.split('/')[1]) return true
      return false
    },
    signOut () {
      this.$store.commit('user', null)
      this.$root.$destroy()
      removeToken()
      // loadModule('main')
      this.$router.push('/')
      document.body.style.backgroundColor = '#0b0e11'
      loadModule('main', 'redirect')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.menu-admin {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: $lp-surface;
  border-bottom: 1px solid $lp-border;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
  color: $lp-text;
  z-index: 9;
  padding-bottom: 10px;
  transition: height 0.3s;
  overflow-y: hidden;
  height: $menu-height;

  &.open {
    height: 100%;
  }
}

.menu-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: $menu-height;
  padding: 0 15px;
}

.menu-logo {
  cursor: pointer;
  // text-align: center;
  img {
    width: auto;
    height: 20px;
  }
}

.menu-icon {
  width: 30px;
  height: 30px;
  padding: 5px;
  cursor: pointer;
  text-align: right;
  i {
    font-size: 20px;
    line-height: 30px;
  }
}

.menu-items {
  flex-grow: 1;
}

.menu-item {
  font-size: 1.1em;
  font-weight: normal;
  padding: 8px 15px;
  cursor: pointer;
  border-left: 3px solid transparent;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
  i {
    width: 20px;
    text-align: center;
    margin-right: 10px;
    color: $lp-text-2;
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
    color: $lp-text;
  }
  &.active {
    background-color: rgba($lp-accent, 0.1);
    border-left-color: $lp-accent;
    color: $lp-accent;
    i {
      color: $lp-accent;
    }
  }
}

@media screen and (min-width: $desktop-width) {
  .menu-admin {
    width: $menu-width-open;
    height: 100%;
    border-bottom: none;
    border-right: 1px solid $lp-border;
  }
  .menu-logo {
    flex-grow: 1;
  }
  .menu-icon {
    display: none;
  }
}

@media print {
  .menu-admin {
    display: none;
  }
}
</style>
